import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ProposalCopyingForRecalSearchPanel = () => {
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Search;
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const { searchCriteria } = proposalCopyingForRecalState;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const resetButtonClicked = useCallback(() => {
        proposalCopyingForRecalVM.onSearchCriteriaResetClick();
    }, [proposalCopyingForRecalVM]);

    const searchButtonClicked = useCallback(() => {

        setIsLoading(true);
        proposalCopyingForRecalVM.searchProposalsForRecal(searchCriteria).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })
    }, [proposalCopyingForRecalVM, searchCriteria])

    const proposalNoChanged = useCallback((fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        fieldValue = fieldValue && fieldValue.toString().replace(/[^0-9*]/g, '');
        proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue);
    }, [proposalCopyingForRecalVM]);


    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "390px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.proposalNo ?? ""}
                fieldValue={searchCriteria?.proposalNo ?? ""}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalNo'}
                maxLength={7}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalNoChanged(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_NO, searchCriteria.proposalNo, proposalNoChanged])

    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "390px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.companyCode ?? ""}
                fieldValue={searchCriteria?.companyCode ?? ""}
                fieldLabel={SCREEN_CONSTANT.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={proposalCopyingForRecalState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COMPANY_CODE, proposalCopyingForRecalState.dynamicOptions.companyCodeDropdownOptions, proposalCopyingForRecalVM, searchCriteria.companyCode])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "390px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria.operatingTml ?? ""}
                fieldValue={searchCriteria?.operatingTml ?? ""}
                fieldLabel={SCREEN_CONSTANT.OPERATING_TML}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                options={proposalCopyingForRecalState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.OPERATING_TML, proposalCopyingForRecalState.dynamicOptions.operatingTmlDropdownOptions, proposalCopyingForRecalVM, searchCriteria.operatingTml])

    const memoEffectiveDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_RANGE}
                width='390px'
                fieldNames={{ startField: "effectiveDateFrom", endField: "effectiveDateTo" }}
                dateRange={{ startDate: searchCriteria.effectiveDateFrom, endDate: searchCriteria.effectiveDateTo }}
                onDatesChange={proposalCopyingForRecalVM.onDateRangeChange}
            />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE_RANGE, proposalCopyingForRecalVM.onDateRangeChange, searchCriteria.effectiveDateFrom, searchCriteria.effectiveDateTo])


    return (
        <div className='side-form-content-left-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{SCREEN_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={proposalCopyingForRecalVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        <CriteriaItemContainer>
                            {memoCompanyCode}
                            {memoOperatingTml}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoProposalNo}
                            {memoEffectiveDateFromTo}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked()} />
            </SidebarActionBar>
        </div>
    );
}

export default ProposalCopyingForRecalSearchPanel;
